import { FormlyFieldConfig } from "@ngx-formly/core";
import { Injector } from "@angular/core";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { TreeNodeOrganisationList } from "../../../Art57Node/ListEntity/TreeNodeOrganisationList";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodePharmaceuticalFormList } from "../../../Art57Node/ListEntity/TreeNodePharmaceuticalFormList";

export class PharmaceuticalFormsQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).pharmaceuticalFormsFields;
    const createChidTemplateParams = {nodeType: 1};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).pharmaceuticalFormsConditions;
       super(injector, [], 'Pharmaceutical Forms', EntityEnum.pharmaceuticalForm,  queryFields, queryConditions,injector.get(Art57Section).medicinalProduct.pharmaceuticalFormTreeNode,TreeNodePharmaceuticalFormList,AutoUploadEntityEnum.pharmaceuticalForm, createChidTemplateParams);       
    }
}